import { render } from "./UserExpenses.vue?vue&type=template&id=2fb5d380"
import script from "./UserExpenses.vue?vue&type=script&lang=js"
export * from "./UserExpenses.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UserExpenses.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fb5d380"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fb5d380', __exports__)) {
    console.log('reload')
    api.reload('2fb5d380', __exports__)
  }
  
  module.hot.accept("./UserExpenses.vue?vue&type=template&id=2fb5d380", () => {
    console.log('re-render')
    api.rerender('2fb5d380', render)
  })

}


export default __exports__